import { withNamespaces } from 'react-i18next'

import Component from './ReportModal'

export default withNamespaces(['LeftoverOnes', 'common', 'sign'])(Component)
